import generateATH2 from "../api/xml/generateATH2";
import {
  getDocDataById,
  getFlutterTime,
  getLocalStringFromFlutter,
} from "../models/DataFunctions";

export const generateComplexModelAttestation = async (
  xml,
  type,
  folder,
  partner,
  orgData,
  modif_thermal = false,
  prefix
) => {
  let ath_request = generateATHRequest(orgData, type, partner);

  let res = await generateATH2(
    xml?.file?.url || "",
    orgData,
    folder.id,
    ath_request,
    modif_thermal,
    prefix
  );
  return res;
};

export const generateATHRequest = (orgData, type, partner) => {
  return {
    maitre_oeuvre: {
      nom: partner?.name || "",
      adresse: partner?.infos?.adresse || "",
      code_postal: partner?.infos?.postal || "",
      ville: partner?.infos?.ville || "",
    },
    signataire: {
      nom: ".................................................",
      entreprise: partner?.name || "",
      qualite: "Maître d'Œuvre",
    },
    infiltrometre: {
      nom: orgData.name,
      adresse: orgData.infos.adresse,
      code_postal: orgData.infos.postal,
      ville: orgData.infos.ville,
    },
    reference: {
      nom: "M ET MME VANDECANDELAERE",
      adresse: "CHEMIN DE LA PLAINE",
      code_postal: "27390",
      ville: "SACQUEVILLE",
      creation_date: getLocalStringFromFlutter(getFlutterTime()),
    },

    type: type,
    logo: orgData.logo,
    footer:
      "Ce document est une attestation de conformité aux exigences de la réglementation thermique",
  };
};
